<template>
<b-modal
v-if="isModalTableSelectedShow"
:visible="isModalTableSelectedShow"
size="xl"
hide-footer
no-close-on-backdrop
@change="(val) => $emit('update:is-modal-table-selected-show', val)"
@shown="getData(contentData)"
>
<template #modal-title>
    Table
</template>
<validation-observer #default="{ handleSubmit }" ref="refFormObserver">
    <b-form
        class="p-2"
        @submit.prevent="handleSubmit(onSubmit)"
        @reset.prevent="resetForm"
    >
        <b-row>
            <b-col md="6">
                <validation-provider
                    #default="validationContext"
                    name="col"
                    rules="min:1"
                >
                    <b-form-group label="Size (columns) :" label-for="col">
                        <b-form-spinbutton
                        v-model="Data.col"
                        min="1"
                        max="12"
                        ></b-form-spinbutton>
                    </b-form-group>
                    <b-form-invalid-feedback>
                        {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                </validation-provider>

            </b-col>
            <b-col md="6">
                <validation-provider
                    #default="validationContext"
                    name="class_extra"
                >
                <b-form-group label="Class Extra" label-for="class_extra">
                    <b-form-input
                    :id="'class_extra'"
                    v-model="Data.class_extra"
                    autofocus
                    :state="getValidationState(validationContext)"
                    trim
                    />
                    <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                </b-form-group>
                </validation-provider>

            </b-col>
        </b-row>
        <b-tabs v-model="tabIndex">
            <b-tabs content-class="mt-1" v-if="langs.length > 0">
                <b-tab
                    v-for="(lang, key) in langs || []"
                    :key="'tab-' + key"
                    :title="lang.name"
                >
                    <validation-provider
                    #default="validationContext"
                    :name="'title_' + lang.code"
                    rules="min:0"
                    >
                    <b-form-group label="Title" :label-for="'title_' + lang.code">
                        <b-form-input
                        :id="'title_' + lang.code"
                        v-model="Data.title[lang.code]"
                        autofocus
                        :state="getValidationState(validationContext)"
                        trim
                        :placeholder="'Title (' + lang.code + ')'"
                        />
                        <b-form-invalid-feedback>
                        {{ validationContext.errors[0] }}
                        </b-form-invalid-feedback>
                    </b-form-group>
                    </validation-provider>
                    <div class="d-flex justify-content-between">
                        <h3>Head Table</h3>
                        <div>
                            <b-button
                            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                            variant="outline-primary"
                            @click="addColumn"
                           
                            
                            >
                                Add Column
                            </b-button>
                        
                        </div>
                        
                    </div>
                   
                    <div class="d-flex gap-3" v-if="Data.columns.length > 0">
                        
                        
                        <div v-for="(itm, ind) in Data.columns">
                            <validation-provider
                                #default="validationContext"
                                :name="'title_' + lang.code"
                                rules="min:0"
                            >
                                <div class="form-group" :class="ind > 0?'ml-2':''">
                                    <label class="text-danger" @click="removeColumn(ind)" v-if="ind > 0">Remove Head {{ ind+1 }}</label>
                                    <label v-else> Head {{ ind+1 }}</label>
                                    <b-form-input
                                    :id="'table_title_' + lang.code"
                                    v-model="itm.title[lang.code]"
                                  
                                    :placeholder="'Title (' + lang.code + ')'"
                                    />
                                  
                                </div>
                               
                            </validation-provider>
                        </div>
                        <div class="ml-2">Action</div>
                        

                    </div>
                    <hr />
                    <h3>Content Table</h3>
                    <div v-for="(row, inde) in Data.rows" v-if="Data.rows.length > 0" class="d-flex">
                        <div v-for="(itm, ind) in row" >
                            <div class="form-group" :class="ind > 0?'ml-2':''">
                                <quill-editor :options="editorOptions" v-model="itm.text[lang.code]" />
                                
                            </div>
                           
                        </div>
                        <div class="ml-2">
                            <b-button
                                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                                variant="outline-danger"
                                @click="removeRow(inde)"
                                
                                
                                >
                                    Remove
                                </b-button>
                        </div>

                    </div>

                    <div class="d-flex mt-3">
                        
                        <b-button
                        v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                        variant="outline-primary"
                        @click="addRow"
                        
                        
                        >
                            Add Row
                        </b-button>
                    </div>
                    <hr />
                    <h3>Note Table</h3>
                    <quill-editor :options="editorOptions" v-model="Data.note[lang.code]" />
                    <hr />

                </b-tab>

            </b-tabs>
           
        </b-tabs>
        <hr />
        <h3>Class width(%)</h3>
        <div class="d-flex" v-if="Data.class_column.length > 0">
            <div v-for="(itm, ind) in Data.class_column">
                
                    <div class="form-group" :class="ind > 0?'ml-2':''">
                        
                        <b-form-input
                        
                        v-model="itm.width"
                        
                        :placeholder="'Width (%)'"
                        />
                        
                    </div>
                    
                
            </div>

        </div>
        <hr />
        <div class="d-flex mt-2">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mr-2"
            type="submit"
          >
            Submit
          </b-button>
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            type="button"
            variant="outline-secondary"
            @click="resetData"
          >
            Cancel
          </b-button>
        </div>
    </b-form>

</validation-observer>
</b-modal>
</template>
<script>
import { $themeConfig } from '@themeConfig'
import {
  BForm, BButton, BFormInvalidFeedback, BFormGroup, BFormInput, BModal, VBModal, BFormSpinbutton,
  BMedia, BMediaAside, BMediaBody, BCardText, BAvatar, BImg, BLink, BFormFile, BRow, BCol, BTabs, 
  BTab, BCard,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import { ref } from "@vue/composition-api";
import store from "@/store";
import { useToast } from "vue-toastification/composition";
import { useInputImageRenderer } from "@core/comp-functions/forms/form-utils";

//validator
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required, alphaNum, email, password, confirmed } from "@validations";
import formValidation from "@core/comp-functions/forms/form-validation";
import { heightTransition } from '@core/mixins/ui/transition'
import { title } from '@/@core/utils/filter';

import "quill/dist/quill.core.css";
// eslint-disable-next-line
import "quill/dist/quill.snow.css";
// eslint-disable-next-line
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
import Quill from 'quill'
const sizeStyle = Quill.import('attributors/style/size')
sizeStyle.whitelist = ['6px', '8px', '10px', '12px', '14px', '16px', '18px', '20px', '24px', '30px', '32px', '36px']
Quill.register(sizeStyle, true)

export default {
components: {
    BForm, BButton, BFormInvalidFeedback, BFormGroup, BFormInput, BModal, VBModal, BFormSpinbutton,
    BMedia, BMediaAside, BMediaBody, BCardText, BAvatar, BImg, BLink, BFormFile, BRow, BCol, BTabs, 
    BTab, BCard,
    ValidationProvider,ValidationObserver,
    quillEditor
},
directives: {
    "b-modal": VBModal,
    Ripple,
},
model: {
    prop: "isModalTableSelectedShow",
    event: "update:is-modal-blocks-selected-show",
},

props: {
    isModalTableSelectedShow: {
        type: Boolean,
        required: true,
    },
    contentData: {
        type: Object,
        required: false,
    },
},
computed: {
    editorOptions (){
        return $themeConfig.snowOption
    } 
},
mixins: [heightTransition],
setup(props, { emit }) {
    console.log('isModalTableSelectedShow',props.isModalTableSelectedShow);
    const langs = ref([]);
    const filter = {
      is_active: 1,
    };
    const tabIndex = ref(0);
    const getData = async function (data) {
        
      const res = await  store.dispatch("app-languages/fetchData", filter)
      if (res.data.success) {
            langs.value = res.data.data;
        }
        
        if(data.tableIndex != undefined){
            const dataValue = data.tables.find((b, index) => index === data.tableIndex)
            if(dataValue) return Data.value = dataValue
        }else{
            Data.value.dataIndex = data.dataIndex;
            Data.value.dataKey = data.dataKey;
            

        }
      //  Data.value = data;

    }
    
    const blankData = {
      
      col: 12,
      title: {},
      note:{},
      
      class_extra: '',
      columns:[
        {
            title:{

            }
        }
      ],
      rows:[],
      class_column:[{
        width:'100'
      }]
     
    };

    const Data = ref(blankData)
    const onSubmit = async () => {
        emit('save-table', Data.value);
        resetData();
    }
    const addColumn = async()=>{
        let column = {
            title:{

            }
        }
        let class_column = {
             width:'100'
        }
        Data.value.columns.push(column);
        Data.value.class_column.push(class_column);
        if( Data.value.rows.length > 0){
            
            Data.value.rows =  await Data.value.rows.map((v, i)=>{
                const r = {
                    text:{

                    }
                }
                v.push(r);
                return v;
                

            });

        }

    }
    const addRow = async()=>{
       // let row = []
      const  row =  await Data.value.columns.map((v)=>{
        const r = {
            text:{

            }
        }
            return r

      });
        //console.log('row',row);
        Data.value.rows.push(row);
        
    }
    const removeColumn = async(index)=>{
        Data.value.columns.splice(index, 1);
        Data.value.class_column.splice(index, 1);
        Data.value.rows =  await Data.value.rows.map((v, i)=>{
                v.splice(index,1);
                return v;
                

        });
    }
    const removeRow = (index)=>{
        Data.value.rows.splice(index, 1);

    }
   
    const resetData = () => {
        const resetData = {
      
            col: 12,
            title: {},
            note:{},
            class_extra: '',
            columns:[
                {
                    title:{

                    }
                }
            ],
            rows:[],
            class_column:[{
                width:'100'
            }]
            
        };
        Data.value = resetData;

        emit("update:is-modal-table-selected-show", false);
        
    };
    const {
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation(resetData);
    return {
        refFormObserver,
        getValidationState,
        resetForm,
        getData,
        onSubmit,
        Data,
        tabIndex,
        langs,
        addColumn,
        removeColumn,
        addRow,
        removeRow,
        resetData

    }
}
}
</script>